import {Component, Inject, Input, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {ConfService} from '../conf.service';
import {KongService} from '../kong.service';
import {ConnecttocrudService} from '../connecttocrud.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatIconRegistry, MatSnackBar} from '@angular/material';
import {ActivatedRoute, Router} from '@angular/router';
import {AppComponent} from '../app.component';
import {DomSanitizer} from '@angular/platform-browser';
import {
    DatadogMetricsComponent,
    DeleteConfirmationComponent,
    LeftpanelComponent,
    LoaderWithProgressComponent, PromoteToEnvironmentComponent
} from '../leftpanel/leftpanel.component';
import {
    CreateGatewayResourceConfirmationComponent,
    EndpointComponent,
    GithubConnectionComponent,
    MetricsComponent,
    ModeOfAccessConfirmationComponent,
    PublishServiceConfirmationComponent,
    SecureApiConfirmationComponent
} from '../manage-entities/manage-entities.component';
import {environment} from '../../environments/environment';
import {saveAs} from 'file-saver';
import JSZip from 'jszip';

declare let $;

@Component({
    selector: 'app-business-logic-api-list',
    templateUrl: './business-logic-api-list.component.html',
    styleUrls: ['./business-logic-api-list.component.css'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({height: '0px', minHeight: '0', display: 'none'})),
            state('expanded', style({height: '*'})),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class BusinessLogicApiListComponent implements OnInit {
    @Input() executors: any;
    @Input() editUrl = '/businesslogic/edit/';
    @Input() historyUrl = '';
    @Input() isEdit = true;
    @Input() executorType: any;
    partner = localStorage.getItem('partner');
    account_id = localStorage.getItem('account');
    pkey = localStorage.getItem('partnerKey');
    itemList = [];

    keyAuthId: any;
    botDetectionId: any;
    cors: any;
    corsId: any;
    acl: any;
    aclId: any;
    rateLimitingId: any;
    requestTerminationId: any;
    requestSizeLimitingId: any;
    ipRestrictionId: any;
    gatewayService: any;
    serviceId: any;
    gatewayRoutes: any;
    gatewayPlugins: any;
    routes: any;
    pathRouteId: any;
    hostRouteId: any;
    pathRouteRateLimitingPluginId: any;
    hostRouteRateLimitingPluginId: any;
    pathRoutePlugins: any;
    hostRoutePlugins: any;
    pathRouteKeyAuthPluginId: any;
    hostRouteKeyAuthPluginId: any;
    error = false;
    errorMessage: string;

    filterData: any[];
    searchText: string;
    columns = ['Actions', 'API Method', 'API Name', 'API Version', 'Published', 'Public Access', 'OAuth 2.0', 'Created', 'Last Updated', 'Test Suite', 'Metrics', 'End Point'];
    // columns = ['API Method', 'APIs', 'Version', 'Scope', 'URL', 'Category', 'API Gateway', 'Active', 'Published'];
    // columns = ['API Method', 'APIs', 'Version', 'API Type', 'Scope', 'URL', 'Active', 'Published', 'Created', 'Duration(Hrs)', 'SLA (%)', 'End Points'];
    DeleteEntityCheck = true;
    metrics: any;
    item = [];
    // columnSearch = ['executor_method_type', 'executor_name', 'executor_version', 'executor_category', 'executor_scope', 'apiUrl'];
    columnSearch = ['', 'executor_method_type', 'executor_name', 'executor_version', 'published', '', '', '', '', '', ''];
    executorMappingToSort = ['', 'executor_method_type', 'executor_name', 'executor_version', '', '', '', 'creationTime', 'lastModifiedTime', '', '', ''];
    settings = {
        text: 'Select attribute(s) to search instantly',
        selectAllText: 'Select All',
        unSelectAllText: 'Unselect All',
        enableSearchFilter: true,
        autoPosition: false
    };
    url = environment.konghost;
    partnerKey = localStorage.getItem('partnerKey');
    gatewayUrl: any;

    constructor(private confPost: ConfService,
                private kong: KongService,
                private _service: ConnecttocrudService,
                public snackBar: MatSnackBar,
                public platform: LeftpanelComponent,
                private route: ActivatedRoute,
                private appComponent: AppComponent,
                private router: Router,
                public dialog: MatDialog, iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {

        platform.dataDeleted.subscribe(response => {
            if (response && response.status && response.type === 'executor') {
                this.removeIndexInmfData(response.name, response.version);
            }
        });

        iconRegistry.addSvgIcon(
            'video',
            sanitizer.bypassSecurityTrustResourceUrl('/assets/img/video.svg'));
        iconRegistry.addSvgIcon(
            'metrics',
            sanitizer.bypassSecurityTrustResourceUrl('/assets/img/metrics.svg'));

        iconRegistry.addSvgIcon(
            'edit-test',
            sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/edit-test.svg'));
        iconRegistry.addSvgIcon(
            'test-results',
            sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/test-results.svg'));
    }

    async ngOnInit() {
        // this.getApiExecutorsByPartnerAccount();
        this.gatewayUrl = 'https://' + await this.platform.getDefaultGatewayURL();

        this.itemList = [];
        for (let t = 0; t < this.columnSearch.length; t++) {
            if (this.columnSearch[t] !== '') {
                const tempObj = {};
                tempObj['id'] = t;
                tempObj['itemName'] = this.columns[t];
                tempObj['filter'] = this.columnSearch[t];
                if (this.columnSearch[t] === 'published') {
                    if (this.executorType !== 'DATAACCESS' && this.executorType !== 'API') {
                        this.itemList.push(tempObj);
                    }
                } else {
                    this.itemList.push(tempObj);
                }
            }
        }
    }

    hasExecutorViewPermission(partner, item) {
        if (item['executor_type'] === 'API') {
            return this.platform.hasAccountPermission('view:' + partner + '=>' + item.account_id + '=>' + item.executor_category + '=>' + item.executor_version);
        } else {
            return this.platform.hasAccountPermission('view:' + partner + '=>' + item.account_id + '=>' + item.executor_name + '=>' + item.executor_version);
        }
    }

    openDeleteConfirmationDialog(executor_name, executor_version): void {
        const deletedata = {};
        deletedata['entity'] = executor_name;
        deletedata['version'] = executor_version;
        const dialogRef = this.dialog.open(DeleteConfirmationComponent, {
            width: '60%',
            data: deletedata
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.deleteApiExecutorsForApi(dialogRef.componentInstance.deleteExecutors,
                    dialogRef.componentInstance.deleteGatewayConfig,
                    executor_name, executor_version);
            }
        });
    }

    removeIndexInmfData(executor, version) {
        const itemDuplicate = this.executors;
        const deleteditem = itemDuplicate.findIndex(p => p && p.executor_name === executor && p.executor_version === version);
        if (deleteditem !== -1) {
            delete this.executors[deleteditem];
        }
        this.searchText = '';
    }

    /*
                Remove API Executors from ApiExecutorModel
             */
    deleteApiExecutorsForApi(deleteExecutors, deleteGatewayConfig, entity, version) {
        if (deleteExecutors) {
            this.confPost.deleteApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.pkey, entity, version).subscribe(data => {
                window.location.reload();
                this.platform.openSnackBar('Deleted the API successfully', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while deleting API Executors for this API. Please try after sometime.');
            });
        }
        if (deleteGatewayConfig) {
            const that = this;
            $.when(this.getGatewayItems(entity)).done(function (data) {
                that.deleteApiGatewayConfigForApi(deleteGatewayConfig, entity);
            });
        }
    }

    checkFilter() {
        if (!this.filterData || this.filterData === [] || this.filterData === null) {
            alert('Please select an attribute to filter.');
            this.searchText = '';
        }
    }

    deleteApiGatewayConfigForApi(deleteGatewayConfig, entity) {
        if (deleteGatewayConfig) {
            this.kong.deletePluginFromApiGateway(this.rateLimitingId).subscribe(ratelimitingplugin => {
                this.kong.deletePluginFromApiGateway(this.keyAuthId).subscribe(keyauthplugin => {
                    this.kong.deletePluginFromApiGateway(this.pathRouteRateLimitingPluginId).subscribe(rate1 => {
                        this.kong.deletePluginFromApiGateway(this.hostRouteRateLimitingPluginId).subscribe(r2 => {
                            this.kong.deletePluginFromApiGateway(this.pathRouteKeyAuthPluginId).subscribe(ke1 => {
                                this.kong.deletePluginFromApiGateway(this.hostRouteKeyAuthPluginId).subscribe(k2 => {
                                    this.kong.deleteRouteFromApiGatewayByNameOrId(this.partner + '-' + this.account_id + '-' + entity + '-path').subscribe(route => {
                                        this.kong.deleteRouteFromApiGatewayByNameOrId(this.partner + '-' + this.account_id + '-' + entity + '-host').subscribe(route1 => {
                                            this.kong.deleteServiceFromApiGatewayByNameOrId(this.partner + '-' + this.account_id + '-' + entity).subscribe(res => {
                                            }, error => {
                                                this.platform.handleErrorGracefully(error, 'Error while deleting the service from API Gateway. Please try after sometime.');
                                            });
                                        }, error => {
                                            this.platform.handleErrorGracefully(error, 'Error while deleting the route from API Gateway. Please try after sometime.');
                                        });
                                    }, error => {
                                        this.platform.handleErrorGracefully(error, 'Error while deleting path from route in API Gateway. Please try after sometime.');
                                    });
                                }, error => {
                                    this.platform.handleErrorGracefully(error, 'Error while deleting Key Auth service from host in API Gateway. Please try after sometime.');
                                });
                            }, error => {
                                this.platform.handleErrorGracefully(error, 'Error while deleting Key Auth service from route in API Gateway. Please try after sometime.');
                            });
                        }, error => {
                            this.platform.handleErrorGracefully(error, 'Error while deleting rate limiting service from host in API Gateway. Please try after sometime.');
                        });
                    }, error => {
                        this.platform.handleErrorGracefully(error, 'Error while deleting rate limiting service from route in API Gateway. Please try after sometime.');
                    });
                }, error => {
                    this.platform.handleErrorGracefully(error, 'Error while deleting Key Auth service from API Gateway. Please try after sometime.');
                });
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while deleting rate limiting service from API Gateway. Please try after sometime.');
            });
        }
    }

    patchPluginInAPIGateway(id, plugin) {
        return new Promise((resolve, reject) => {
            this.kong.patchPluginInApiGateway(id, plugin).subscribe(response => {
                resolve('success');
            }, error => {
                resolve('failed');
            });
        });
    }

    getCreatedDate(val) {
        if (val) {
            return this.platform.timeConverter(val);
        } else {
            return '';
        }
    }

    getLastModifiedData(val, val1) {
        if (val) {
            return this.platform.timeConverter(val);
        } else {
            return this.platform.timeConverter(val1);
        }
    }

    openMetricsDialog(partner, account, entity, version) {
        const dialogRef = this.dialog.open(DatadogMetricsComponent, {
            width: '465px',
            height: '650px',
            data: {
                partner: partner,
                account: account,
                APIName: entity,
                version: version
            }
        });

        dialogRef.afterClosed().subscribe(response => {
            if (response && response === 'redirect') {
                this.router.navigateByUrl('devex?partner=' + partner + '&account=' + account + '&executor_name=' + entity + '&executor_version=' + version);
            }
        });
    }

    // openMetricsDialog(partner, account, entity, version): void {
    //   const data = {};
    //   data['partner'] = partner;
    //   data['account'] = account;
    //   data['entity'] = entity;
    //   data['version'] = version;
    //   data['url'] = this.url;
    //   data['partnerKey'] = this.partnerKey;
    //   const dialogRef = this.dialog.open(MetricsComponent, {
    //     width: '80%',
    //     data: data
    //   });
    //
    //   dialogRef.afterClosed().subscribe(result => {
    //   });
    // }

    openDialog(partner, account, entity, version): void {
        const data = {};
        data['partner'] = partner;
        data['account'] = account;
        data['entity'] = entity;
        data['version'] = version;
        data['url'] = this.gatewayUrl;
        data['partnerKey'] = this.partnerKey;
        data['type'] = 'executor';
        const dialogRef = this.dialog.open(EndpointComponent, {
            width: '80%',
            height: '30%',
            data: data,
        });

        dialogRef.afterClosed().subscribe(result => {
        });
    }

    configureIPRestrictionAndMakeItPublic(partner, account, entity, version, resp) {

        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            width: 'auto',
            height: 'auto',
        });

        this.kong.getDefaultPlugins();
        this.kong.createPluginForServiceInGateway({name: partner + '-' + account + '-' + entity + '-' + version}, this.kong.ipRestriction, {}).then(serviceResp => {
            this.kong.getRoutesForAServiceFromApiGateway(partner + '-' + account + '-' + entity + '-' + version).subscribe(async routeResp => {
                if (routeResp) {
                    let gatewayRoute: any;
                    gatewayRoute = routeResp;
                    for (const route of gatewayRoute['data']) {
                        if (route) {
                            await this.kong.createPluginForRouteInGateway({name: route['name']}, this.kong.ipRestriction, {}).then(routePluginResp => {

                            }, error => {
                                if (error.status === 409) {
                                    this.kong.getPluginsForRouteByPluginNameInApiGateway(route['name'], 'ip-restriction').subscribe(async plugin => {
                                        if (plugin) {
                                            const pluginData = plugin;
                                            const id = pluginData.id;
                                            pluginData.enabled = false;
                                            await this.patchPluginInAPIGateway(id, pluginData);
                                        }
                                    });
                                }
                            });
                        }
                    }
                }
                loaderDialog.close();
                resp['scopeOfAccess'] = 'public';
                resp['published'] = true;
                const methods1 = [];
                if (resp && resp['methods']) {
                    for (const method of resp['methods']) {
                        if (method !== 'OPTIONS') {
                            methods1.push(method);
                        }
                    }
                    resp['methods'] = methods1;
                }
                resp['lastModifiedTime'] = Date.now();
                this.confPost.updateApiExecutorForPartnerAccount(partner, account, resp['id'], resp).subscribe(updateResp => {
                    this.platform.updateAPIAuditLog(partner, account, resp['executor_name'], resp['executor_version'], resp['executor_type'], resp, resp);
                    this.platform.refreshExecutors();
                    this.platform.openSnackBar('API has been successfully configured with IP Restriction setting and made publicly accessible.', 'Success', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            }, error => {
                loaderDialog.close();
            });
        }, error => {
            loaderDialog.close();
        });
    }

    togglePublicAccess(event, partner, account, entity, version, resp) {
        this.kong.getServicesFromApiGatewayByNameOrId(partner + '-' + account + '-' + entity + '-' + version).subscribe(gatewayService => {
            if (gatewayService) {
                this.kong.getPluginsForServiceByPluginNameInApiGateway(gatewayService['name'], 'ip-restriction').subscribe(plugin => {
                    if (plugin) {
                        let pluginData = plugin;
                        const id = pluginData.id;
                        const publishdata = {};
                        publishdata['entity'] = entity;
                        publishdata['version'] = version;
                        publishdata['scopeOfAccess'] = resp['scopeOfAccess'];
                        publishdata['published'] = resp['published'];
                        publishdata['pluginData'] = pluginData;
                        const dialogRef = this.dialog.open(SecureApiConfirmationComponent, {
                            width: '60%',
                            data: publishdata
                        });
                        dialogRef.afterClosed().subscribe(async result => {
                            if (result === 'unsecure') {
                                // Disable IP Restriction Plugin
                                pluginData = publishdata['pluginData'];
                                pluginData.enabled = false;

                                await this.patchPluginInAPIGateway(id, pluginData);
                                this.kong.getRoutesForAServiceFromApiGateway(gatewayService['id']).subscribe(routeResp => {
                                    if (routeResp) {
                                        let gatewayRoute: any;
                                        gatewayRoute = routeResp;
                                        for (const route of gatewayRoute['data']) {
                                            if (route) {
                                                this.kong.getPluginsForRouteByPluginNameInApiGateway(route['name'], 'ip-restriction').subscribe(async routePlugin => {
                                                    if (routePlugin) {
                                                        const pluginData1 = routePlugin;
                                                        const id1 = pluginData1.id;
                                                        pluginData1.enabled = false;
                                                        await this.patchPluginInAPIGateway(id1, pluginData1);
                                                    }
                                                });
                                            }
                                        }
                                    }
                                    resp['scopeOfAccess'] = 'public';
                                    resp['lastModifiedTime'] = Date.now();
                                    this.confPost.updateApiExecutorForPartnerAccount(partner, account, resp['id'], resp).subscribe(updateResp => {
                                        this.platform.updateAPIAuditLog(partner, account, resp['executor_name'], resp['executor_version'], resp['executor_type'], resp, resp);
                                        this.platform.refreshExecutors();
                                        this.platform.openSnackBar('API has been provided the public access successfully.', 'Success', {
                                            duration: 5000,
                                            verticalPosition: 'top',
                                            horizontalPosition: 'center'
                                        });
                                    }, updateError => {
                                        pluginData.enabled = true;
                                        this.kong.updatePluginInApiGateway(id, pluginData).subscribe(response => {
                                            event.source.checked = !event.source.checked;
                                            this.platform.handleErrorGracefully(updateError, 'Error while providing public access to your API. Please try again after sometime');
                                        });
                                    });
                                });
                            } else if (result === 'secure') {
                                // Enable IP Restriction Plugin
                                pluginData = publishdata['pluginData'];
                                pluginData.enabled = true;

                                await this.patchPluginInAPIGateway(id, pluginData);
                                this.kong.getRoutesForAServiceFromApiGateway(gatewayService['id']).subscribe(routeResp => {
                                    if (routeResp) {
                                        let gatewayRoute: any;
                                        gatewayRoute = routeResp;
                                        for (const route of gatewayRoute['data']) {
                                            if (route) {
                                                this.kong.getPluginsForRouteByPluginNameInApiGateway(route['name'], 'ip-restriction').subscribe(async routePlugin => {
                                                    if (routePlugin) {
                                                        const pluginData1 = routePlugin;
                                                        const id1 = pluginData1.id;
                                                        pluginData1.enabled = true;
                                                        await this.patchPluginInAPIGateway(id1, pluginData1);
                                                    }
                                                });
                                            }
                                        }
                                    }
                                    resp['scopeOfAccess'] = 'private';
                                    resp['lastModifiedTime'] = Date.now();
                                    this.confPost.updateApiExecutorForPartnerAccount(partner, account, resp['id'], resp).subscribe(updateResp => {
                                        this.platform.updateAPIAuditLog(partner, account, resp['executor_name'], resp['executor_version'], resp['executor_type'], resp, resp);
                                        this.platform.refreshExecutors();
                                        this.platform.openSnackBar('API has been restricted for public access successfully.', 'Success', {
                                            duration: 5000,
                                            verticalPosition: 'top',
                                            horizontalPosition: 'center'
                                        });
                                    }, updateError => {
                                        pluginData.enabled = false;
                                        this.kong.updatePluginInApiGateway(id, pluginData).subscribe(response => {
                                            event.source.checked = !event.source.checked;
                                            this.platform.handleErrorGracefully(updateError, 'Error while restricting the public access for your API. Please try again after sometime');
                                        });
                                    });
                                });
                            } else {
                                event.source.checked = !event.source.checked;
                            }
                        });
                    } else {
                        // NO PLUGIN
                        this.configureIPRestrictionAndMakeItPublic(partner, account, entity, version, resp);
                        // event.source.checked = !event.source.checked;
                    }
                });
            } else {
                const dialogRef1 = this.dialog.open(CreateGatewayResourceConfirmationComponent, {
                    width: '60%',
                    height: 'auto',
                    data: {
                        entity: entity,
                        version: version
                    }
                });
                dialogRef1.afterClosed().subscribe(result => {
                    this.configureDefaultGatewaySettings(partner, account, entity, version, resp, event, result);
                });
            }
        }, error => {
            if (error.status === 404) {
                const dialogRef1 = this.dialog.open(CreateGatewayResourceConfirmationComponent, {
                    width: '60%',
                    height: 'auto',
                    data: {
                        entity: entity,
                        version: version
                    }
                });
                dialogRef1.afterClosed().subscribe(result => {
                    this.configureDefaultGatewaySettings(partner, account, entity, version, resp, event, result);
                });
            }
        });
    }

    configureDefaultGatewaySettings(partner, account, entity, version, resp, event, result) {
        const logTimeStamp = Date.now();
        if (result === 'configure') {
            const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                width: 'auto',
                height: 'auto',
                data: {
                    message: ''
                }
            });
            this.kong.configureApiGatewayWithIpRestrictionWithMethods(partner, account, entity, version, false, true, [resp['executor_method_type']], logTimeStamp, '').then(response => {
                const methods = [];
                if (resp && resp['methods']) {
                    for (const method of resp['methods']) {
                        if (method !== 'OPTIONS') {
                            methods.push(method);
                        }
                    }
                    resp['methods'] = methods;
                }
                resp['published'] = true;
                resp['scopeOfAccess'] = 'public';
                resp['lastModifiedTime'] = Date.now();
                this.confPost.updateApiExecutorForPartnerAccount(partner, account, resp['id'], resp).subscribe(updResp => {
                    loaderDialog.close();
                    const dialogRef2 = this.dialog.open(ModeOfAccessConfirmationComponent, {
                        width: '60%',
                        height: 'auto',
                        disableClose: true
                    });
                    dialogRef2.afterClosed().subscribe(result1 => {
                        if (result1 === 'public') {
                            resp['scopeOfAccess'] = 'public';
                            resp['published'] = true;
                            resp['lastModifiedTime'] = Date.now();
                            this.confPost.updateApiExecutorForPartnerAccount(partner, account, resp['id'], resp).subscribe(updateResp => {
                                this.platform.updateAPIAuditLog(partner, account, resp['executor_name'], resp['executor_version'], resp['executor_type'], resp, resp);
                                this.platform.refreshExecutors();
                                this.platform.openSnackBar('API has been provided the public access successfully.', 'Success', {
                                    duration: 5000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                            });
                        } else if (result1 === 'private') {
                            this.kong.getServicesFromApiGatewayByNameOrId(partner + '-' + account + '-' + entity + '-' + version).subscribe(gatewayService1 => {
                                if (gatewayService1) {
                                    this.kong.getPluginsForServiceByPluginNameInApiGateway(gatewayService1['name'], 'ip-restriction').subscribe(async plugin => {
                                        if (plugin) {
                                            const pluginData = plugin;
                                            const id = pluginData.id;
                                            pluginData.enabled = true;

                                            await this.patchPluginInAPIGateway(id, pluginData);
                                            this.kong.getRoutesForAServiceFromApiGateway(gatewayService1['id']).subscribe(routeResp => {
                                                if (routeResp) {
                                                    let gatewayRoute: any;
                                                    gatewayRoute = routeResp;
                                                    for (const route of gatewayRoute['data']) {
                                                        if (route) {
                                                            this.kong.getPluginsForRouteByPluginNameInApiGateway(route['name'], 'ip-restriction').subscribe(async routePlugin => {
                                                                if (routePlugin) {
                                                                    const pluginData1 = routePlugin;
                                                                    const id1 = pluginData1.id;
                                                                    pluginData1.enabled = true;
                                                                    await this.patchPluginInAPIGateway(id1, pluginData1);
                                                                }
                                                            });
                                                        }
                                                    }
                                                }
                                                resp['scopeOfAccess'] = 'private';
                                                resp['published'] = true;
                                                resp['lastModifiedTime'] = Date.now();
                                                this.confPost.updateApiExecutorForPartnerAccount(partner, account, resp['id'], resp).subscribe(updateResp => {
                                                    this.platform.updateAPIAuditLog(partner, account, resp['executor_name'], resp['executor_version'], resp['executor_type'], resp, resp);
                                                    this.platform.refreshExecutors();
                                                    this.platform.openSnackBar('API has been restricted for public access successfully.', 'Success', {
                                                        duration: 5000,
                                                        verticalPosition: 'top',
                                                        horizontalPosition: 'center'
                                                    });
                                                }, updateError => {
                                                    pluginData.enabled = false;
                                                    this.kong.updatePluginInApiGateway(id, pluginData).subscribe(response => {
                                                        event.source.checked = !event.source.checked;
                                                        this.platform.handleErrorGracefully(updateError, 'Error while restricting the public access for your API. Please try again after sometime');
                                                    });
                                                });
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    });
                }, error => {
                    loaderDialog.close();
                });
            }, error => {
                loaderDialog.close();
                event.source.checked = !event.source.checked;
                this.platform.openSnackBar('Error while configuring gateway settings for your API. Please try again after sometime', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        } else {
            event.source.checked = !event.source.checked;
        }
    }

    openScopeOfAccessConfirmationDialog(event, partner, account, entity, version): void {

        const entityLoader = this.dialog.open(LoaderWithProgressComponent, {
            width: 'auto',
            height: 'auto',
            data: {
                message: ''
            }
        });
        this.confPost.getAPIExecutorForPartnerAccount(partner, account, localStorage.getItem('partnerKey'), entity, version).subscribe(resp => {
            if (resp) {
                entityLoader.close();
                const status = resp['scopeOfAccess'];
                this.togglePublicAccess(event, partner, account, entity, version, resp);
            } else {
                event.source.checked = !event.source.checked;
                entityLoader.close();
                this.platform.openSnackBar('Error while retrieving your API. Please try again after sometime', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        }, error => {
            event.source.checked = !event.source.checked;
            entityLoader.close();
            this.platform.handleErrorGracefully(error, 'Error while retrieving your API. Please try again after sometime');
        });
    }

    openPublishConfirmationDialog(event, partner, account, entity, version, type): void {

        const entityLoader = this.dialog.open(LoaderWithProgressComponent, {
            width: 'auto',
            height: 'auto',
            data: {
                message: ''
            }
        });

        this.confPost.getAPIExecutorForPartnerAccount(partner, account, localStorage.getItem('partnerKey'), entity, version).subscribe(resp => {
            entityLoader.close();
            if (resp) {
                const publishdata = {};
                publishdata['entity'] = entity;
                publishdata['version'] = version;
                publishdata['scopeOfAccess'] = resp['scopeOfAccess'];
                publishdata['published'] = resp['published'];
                const dialogRef = this.dialog.open(PublishServiceConfirmationComponent, {
                    width: '60%',
                    data: publishdata
                });


                dialogRef.afterClosed().subscribe(result => {
                    if (result === 'publish') {
                        const logTimeStamp = Date.now();
                        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                            width: 'auto',
                            height: 'auto',
                            // data: {
                            //   message: 'Publishing your API.... Please kindly wait   '
                            // }
                        });
                        this.kong.configureApiGatewayWithIpRestrictionWithMethods(partner, account, entity, version, resp['scopeOfAccess'] !== 'public', true, [resp['executor_method_type']], logTimeStamp, '').then(response => {
                            resp['published'] = true;
                            resp['scopeOfAccess'] = 'private';
                            resp['lastModifiedTime'] = Date.now();

                            this.confPost.updateApiExecutorForPartnerAccount(partner, account, resp['id'], resp).subscribe(updateResp1 => {
                                this.kong.getPluginsForServiceByPluginNameInApiGateway(partner + '-' + account + '-' + entity + '-' + version, 'ip-restriction').subscribe(plugin => {
                                    if (plugin) {
                                        let pluginData = plugin;
                                        const id = pluginData.id;
                                        const publishdata1 = {};
                                        publishdata1['entity'] = entity;
                                        publishdata1['version'] = version;
                                        publishdata1['scopeOfAccess'] = resp['scopeOfAccess'];
                                        publishdata1['published'] = resp['published'];
                                        publishdata1['pluginData'] = pluginData;
                                        const dialogRef1 = this.dialog.open(SecureApiConfirmationComponent, {
                                            width: '60%',
                                            data: publishdata
                                        });
                                        dialogRef1.afterClosed().subscribe(async result1 => {
                                            if (result1 === 'unsecure') {
                                                // Disable IP Restriction Plugin
                                                pluginData = publishdata1['pluginData'];
                                                pluginData.enabled = false;

                                                await this.patchPluginInAPIGateway(id, pluginData);
                                                this.kong.getRoutesForAServiceFromApiGateway(partner + '-' + account + '-' + entity + '-' + version).subscribe(routeResp => {
                                                    if (routeResp) {
                                                        let gatewayRoute: any;
                                                        gatewayRoute = routeResp;
                                                        for (const route of gatewayRoute['data']) {
                                                            if (route) {
                                                                this.kong.getPluginsForRouteByPluginNameInApiGateway(route['name'], 'ip-restriction').subscribe(async routePlugin => {
                                                                    if (routePlugin) {
                                                                        const pluginData1 = routePlugin;
                                                                        const id1 = pluginData1.id;
                                                                        pluginData1.enabled = false;
                                                                        await this.patchPluginInAPIGateway(id1, pluginData1);
                                                                    }
                                                                });
                                                            }
                                                        }
                                                    }
                                                    resp['scopeOfAccess'] = 'public';
                                                    resp['lastModifiedTime'] = Date.now();
                                                    this.confPost.updateApiExecutorForPartnerAccount(partner, account, resp['id'], resp).subscribe(updateResp => {
                                                        this.platform.updateAPIAuditLog(partner, account, resp['executor_name'], resp['executor_version'], resp['executor_type'], resp, resp);
                                                        this.platform.refreshExecutors();
                                                        this.platform.openSnackBar('API has been published successfully with public access', 'Success', {
                                                            duration: 5000,
                                                            verticalPosition: 'top',
                                                            horizontalPosition: 'center'
                                                        });
                                                    }, updateError => {
                                                        pluginData.enabled = true;
                                                        this.kong.updatePluginInApiGateway(id, pluginData).subscribe(response => {
                                                            event.source.checked = !event.source.checked;
                                                            this.platform.handleErrorGracefully(updateError, 'Error while providing public access to your API. Please try again after sometime');
                                                        });
                                                    });
                                                });
                                            } else {
                                                this.confPost.updateApiExecutorForPartnerAccount(partner, account, resp['id'], resp).subscribe(updateResp => {
                                                    this.platform.updateAPIAuditLog(partner, account, resp['executor_name'], resp['executor_version'], resp['executor_type'], resp, resp);
                                                    this.platform.refreshExecutors();
                                                    this.platform.openSnackBar('API has been published successfully with ' + resp['scopeOfAccess'] + ' access', 'Success', {
                                                        duration: 5000,
                                                        verticalPosition: 'top',
                                                        horizontalPosition: 'center'
                                                    });
                                                }, updateError => {
                                                    this.platform.deleteExecutorWithDependencies(false, false, true, partner, account, localStorage.getItem('partnerKey'), entity, version, type).then(resp1 => {
                                                        event.source.checked = !event.source.checked;
                                                        this.platform.handleErrorGracefully(updateError, 'Error while publishing your API. Please try again after sometime');
                                                    });
                                                });
                                            }
                                        });
                                    } else {
                                        this.configureIPRestrictionAndMakeItPublic(partner, account, entity, version, resp);
                                    }
                                });
                                loaderDialog.close();
                            }, updateError => {
                                this.platform.deleteExecutorWithDependencies(false, false, true, partner, account, localStorage.getItem('partnerKey'), entity, version, type).then(resp1 => {
                                    event.source.checked = !event.source.checked;
                                    loaderDialog.close();
                                    this.platform.handleErrorGracefully(updateError, 'Error while publishing your API. Please try again after sometime');
                                });
                            });
                        }, error => {
                            loaderDialog.close();
                            this.platform.handleErrorGracefully(error, 'Error while publishing your API. Please try again after sometime');
                            // Reverse the toggle to previous state
                        });
                    } else if (result === 'unpublish') {
                        this.platform.deleteExecutorWithDependencies(false, false, true, partner, account, localStorage.getItem('partnerKey'), entity, version, type).then(resp1 => {
                            resp['published'] = false;
                            resp['scopeOfAccess'] = 'private';
                            resp['lastModifiedTime'] = Date.now();
                            this.confPost.updateApiExecutorForPartnerAccount(partner, account, resp['id'], resp).subscribe(updateResp => {
                                this.platform.updateAPIAuditLog(partner, account, resp['executor_name'], resp['executor_version'], resp['executor_type'], resp, resp);
                                this.platform.refreshExecutors();
                                this.platform.openSnackBar('API unpublished successfully.', 'Success', {
                                    duration: 5000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                            }, updateError => {
                                this.kong.configureApiGatewayWithIpRestrictionWithMethods(partner, account, entity, version, resp['scopeOfAccess'] !== 'public', true, [resp['executor_method_type']], Date.now(), '').then(resp1 => {
                                    event.source.checked = !event.source.checked;
                                    this.platform.handleErrorGracefully(updateError, 'Error while publishing your API. Please try again after sometime');
                                });
                            });
                        }, error => {
                            event.source.checked = !event.source.checked;
                            this.platform.handleErrorGracefully(error, 'Error while unpublishing your API. Please try again after sometime');
                        });
                    } else {
                        event.source.checked = !event.source.checked;
                    }
                });
            }
        }, error => {
            event.source.checked = !event.source.checked;
            entityLoader.close();
            this.platform.handleErrorGracefully(error, 'Error while retrieving your API. Please try again after sometime');
        });
    }

    getGatewayItems(entity) {
        this.error = false;
        this.kong.getServicesFromApiGatewayByNameOrId(this.partner + '-' + this.account_id + '-' + entity).subscribe(service => {
                this.gatewayService = service;
                this.serviceId = this.gatewayService.id;
                this.kong.getRoutesForAServiceFromApiGateway(this.partner + '-' + this.account_id + '-' + entity).subscribe(routes => {
                    this.gatewayRoutes = routes;
                    this.routes = this.gatewayRoutes.data;
                    this.routes.forEach(route => {
                        if (route.name === this.partner + '-' + this.account_id + '-' + entity + '-path') {
                            this.pathRouteId = route.id;

                        } else if (route.name === this.partner + '-' + this.account_id + '-' + entity + '-host') {
                            this.hostRouteId = route.id;
                        }
                    });

                    this.kong.getPluginsForRouteInApiGateway(this.pathRouteId).subscribe(pathRoutePluginRes => {
                        this.pathRoutePlugins = pathRoutePluginRes;
                        this.pathRoutePlugins.data.forEach(pathRoutePlugin => {
                            if (pathRoutePlugin.name === 'rate-limiting') {
                                this.pathRouteRateLimitingPluginId = pathRoutePlugin.id;
                            } else if (pathRoutePlugin.name === 'key-auth') {
                                this.pathRouteKeyAuthPluginId = pathRoutePlugin.id;
                            }
                        });
                    }, error => {
                        this.platform.handleErrorGracefully(error, 'Error while retrieving the plugins for the path in route from API Gateway. Please try after sometime.');
                    });
                    this.kong.getPluginsForRouteInApiGateway(this.hostRouteId).subscribe(hostPluginRes => {
                        this.hostRoutePlugins = hostPluginRes;
                        this.hostRoutePlugins.data.forEach(hostRoutePlugin => {
                            if (hostRoutePlugin.name === 'rate-limiting') {
                                this.hostRouteRateLimitingPluginId = hostRoutePlugin.id;
                            } else if (hostRoutePlugin.name === 'key-auth') {
                                this.hostRouteKeyAuthPluginId = hostRoutePlugin.id;
                            }
                        });
                    }, error => {
                        this.platform.handleErrorGracefully(error, 'Error while retrieving the plugins for the host in route from API Gateway. Please try after sometime.');
                    });


                }, error => {
                    this.platform.handleErrorGracefully(error, 'Error while deleting routes for the service from API Gateway. Please try after sometime.');
                });
                this.kong.getPluginsForServiceInApiGateway(this.partner + '-' + this.account_id + '-' + entity).subscribe(plugins => {
                    this.gatewayPlugins = plugins;
                    this.gatewayPlugins.data.forEach(plugin => {
                        if (plugin.name === 'rate-limiting') {
                            this.rateLimitingId = plugin.id;

                        } else if (plugin.name === 'key-auth') {
                            this.keyAuthId = plugin.id;

                        } else if (plugin.name === 'request-size-limiting') {
                            this.requestSizeLimitingId = plugin.id;

                        } else if (plugin.name === 'request-termination') {
                            this.requestTerminationId = plugin.id;

                        } else if (plugin.name === 'cors') {
                            this.corsId = plugin.id;

                        } else if (plugin.name === 'acl') {
                            this.aclId = plugin.id;

                        } else if (plugin.name === 'bot-detection') {
                            this.botDetectionId = plugin.id;

                        } else if (plugin.name === 'ip-restriction') {
                            this.ipRestrictionId = plugin.id;
                        } else {
                        }
                    });
                }, error => {
                    this.platform.handleErrorGracefully(error, 'Error while retrieving the plugins for the service from API Gateway. Please try after sometime.');
                });
            },
            error => {
                this.error = true;
                this.errorMessage = (error.error.message ? error.error.message : error.error);
            });
    }

    promoteAPI(item) {
        this.dialog.open(PromoteToEnvironmentComponent, {
            height: '40%',
            width: '30%',
            data: {
                partner: this.partner,
                account: this.account_id,
                entity: item.executor_name,
                version: item.executor_version,
                type: item.executor_type
            }
        });
    }

    openGitHubDialog(partner, account, entityname, version, type) {
        // console.log(partner,account,executor_name,executor_version,executor_type);
        const dialogRef = this.dialog.open(GithubConnectionSqlComponent, {
            minWidth: '30vw',
            data: {
                partner: partner,
                account: account,
                entityname: entityname,
                version: version,
                type: type
            }
        });

    }

}

@Component({
    selector: 'github-connection-sql-dialog',
    templateUrl: 'github-connection-sql.html',
    styleUrls: ['github-connection-sql.css'],
})
export class GithubConnectionSqlComponent implements OnInit {
    accessToken = '';
    github_handle = '';
    github_repo = [];
    github_branches = [];
    isConnected = false;
    selectedRepo = '';
    selectedBranch = '';
    isEdit = false;
    id: any;
    selectedCode = '';
    codes = ['Python', 'Java'];
    path = '';
    repoPath = '';
    filePath = '';
    fileName = '';
    isCommitted: boolean;
    committedFilePath = '';
    committedRepoPath = '';
    committedBranch = '';
    committedPath = '';
    committedSha = '';
    committedFileName = '';
    incorrectToken = false;
    defaultPath = '';
    author = '';
    committedDate = '';
    commitPath = '';
    isRedeployed = false;
    executorData: any;
    newRepo = '';
    commitMessage = '';
    code = '';
    viewCode = false;
    sourceCodeFilesList = [];
    selectedFile = '';
    codeList = [];


    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<GithubConnectionSqlComponent>, public confPost: ConfService) {
        this.selectedCode = 'Python';
        this.viewCode = true;
        this.viewSourceCode();


    }

    ngOnInit() {
    }

    createRepository() {
        const payload = {
            'name': this.newRepo
        };
        this.confPost.createGitRepo(this.accessToken, payload).subscribe(res => {
            if (res) {

                this.platform.openSnackBar('GitHub repository created.', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.confPost.getGitUserRepo(this.accessToken).subscribe(res1 => {
                    this.github_repo = [];
                    let temp: any = res1;
                    if (res1) {
                        for (let i = 0; i < temp.length; i++) {
                            if (temp[i]['owner']['login'] === this.github_handle) {
                                this.github_repo.push(temp[i]['name']);
                            }
                        }
                    }
                    this.selectedRepo = this.newRepo;
                    this.newRepo = '';
                    // this.onChangeRepo(this.newRepo);
                    this.github_branches = ['main'];
                    this.repoPath = this.github_handle + '/' + this.selectedRepo;
                    this.defaultPath = this.github_handle + '/' + this.selectedRepo + '/';
                });
            }
        }, err1 => {
            this.platform.openSnackBar('Failed to create new repository, Please try again.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    generateAccessToken() {
        window.open('https://github.com/settings/tokens', '_blank').focus();
    }

    submitAccessToken() {
        this.confPost.getGitUser(this.accessToken).subscribe(res => {
            if (res && res['login'].length > 0) {
                this.github_handle = res['login'];
                if (!this.isRedeployed) {
                    this.defaultPath = this.github_handle + '/';
                }
                this.confPost.getGitUserRepo(this.accessToken).subscribe(res1 => {
                    this.github_repo = [];
                    let temp: any = res1;
                    if (res1) {
                        for (let i = 0; i < temp.length; i++) {
                            if (temp[i]['owner']['login'] === this.github_handle) {
                                this.github_repo.push(temp[i]['name']);
                            }
                        }
                    }
                    this.isConnected = true;
                    this.incorrectToken = false;
                });
            }
        }, error => {
            this.isConnected = false;
            this.incorrectToken = true;
        });

    }

    onChangeRepo(repo) {
        this.github_branches = [];
        this.confPost.getGitUserBranch(this.accessToken, this.github_handle, repo).subscribe(res1 => {
            let temp: any = res1;
            if (res1) {
                for (let i = 0; i < temp.length; i++) {
                    this.github_branches.push(temp[i]['name']);
                }
            }
            if (this.github_branches.length === 0) {
                this, this.github_branches.push('main');
            }
        });
        this.repoPath = this.github_handle + '/' + this.selectedRepo;
        this.defaultPath = this.github_handle + '/' + this.selectedRepo + '/';

    }

    onChangeLanguage(language) {
        if (this.viewCode) {
            this.viewSourceCode();
        }
    }

    onChangeFile(index) {
        this.code = this.codeList[0];
    }

    downloadCode() {
        if (this.selectedCode === 'Python') {
            saveAs(new Blob([this.code]), this.sourceCodeFilesList[0]);

        }
    }

    closeSourceCode() {
        this.viewCode = false;
    }

    viewSourceCode() {
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        this.confPost.getApiExecutorByPartnerAccountByNameAndVersion(this.data['partner'], this.data['account'], this.data['entityname'], this.data['version']).subscribe(resp => {
            if (resp && resp !== undefined && resp !== null) {
                const data = resp;
                const generatedCode = this.generateCode(data, this.selectedCode);
                let filename = '';
                this.codeList = generatedCode;
                if (this.selectedCode === 'Python') {
                    filename = this.data['entityname'] + '.py';
                } else if (this.selectedCode === 'Java') {
                    filename = this.data['entityname'] + '.java';
                }
                this.code = generatedCode[0];
                this.sourceCodeFilesList = [filename];
                this.selectedFile = '0';
                this.viewCode = true;
                loaderDialog.close();

            }
        }, err => {
            loaderDialog.close();
            this.platform.openSnackBar('Error in viewing source code. Please try again later.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    viewCommitPage() {

        const queryParam = 'account=' + this.data['account'] + '&partner=' + this.data['partner'] + '&entity_name=' + this.data['entityname'] + '&version=' + this.data['version'];
        this.confPost.getData('services', 'services', 'v1', 'githubCommits', queryParam).subscribe(res => {
            if (res && res !== undefined && res !== null) {
                const temp: any = res;
                if (temp.length > 0) {
                    this.isCommitted = true;
                    const latestCommitDate = new Date(Math.max.apply(null, temp.map(function (e) {
                        return new Date(e.commit_date);
                    })));
                    for (const item of temp) {
                        if (String(new Date(item['commit_date'])) === String(latestCommitDate)) {
                            this.committedFilePath = item['file_path'];
                            this.author = item['author'];
                            this.committedDate = item['commit_date'];
                            this.commitPath = item['commit_path'];
                            this.defaultPath = item['repository_path'] + '/';
                            this.committedRepoPath = item['repository_path'];
                            this.committedPath = item['path'];
                            this.selectedBranch = item['branch'];
                            this.selectedCode = item['code'];
                            this.path = item['path'];
                            this.selectedRepo = item['repository_path'].split('/')[1];
                            this.committedSha = item['sha'];
                            this.committedFileName = item['file_name'];
                            const committedAttributes = item['attributes'];
                            this.commitMessage = item['commit_message'];
                            this.confPost.getApiExecutorByPartnerAccountByNameAndVersion(this.data['partner'], this.data['account'], this.data['entityname'], this.data['version']).subscribe(resp => {
                                if (resp && resp !== undefined && resp !== null) {
                                    const data1 = resp;
                                    this.executorData = resp;
                                    if (this.selectedCode === 'Python') {
                                        if (committedAttributes !== JSON.stringify(data1['executors'][0]['query'])) {
                                            this.isRedeployed = true;
                                        }
                                    }
                                }
                            });
                        }
                    }
                } else {
                    this.isCommitted = false;
                }
            } else {
                this.isCommitted = false;
            }
        }, error => {
            this.isCommitted = false;
        });
    }

    generateCode(data, code) {
        let codeArray = [];
        let PySnippet = '';
        if (code === 'Python') {
            PySnippet = `from flask import Flask, request, redirect ,  json, Response
import pyodbc

app = Flask(__name__)

def connection():
    server = 'myserver'
    database = '` + data['executors'][0]['database']['database_name'] + `'
    username = 'myusername'
    password = 'mypassword'
    connection_str = 'DRIVER={ODBC Driver 17 for SQL Server};SERVER=' + server + ';DATABASE=' + database + ';UID=' + username + ';PWD=' + password
    conn = pyodbc.connect(connection_str)
    return conn


@app.route('/` + data['executor_name'] + `', methods=['` + data['executor_method_type'] + `'])
def create():
    data = request.json
    conn = connection()
    cursor = conn.cursor()
    response = cursor.execute("` + data['executors'][0]['query'] + `")
    conn.commit()
    conn.close()
    return Response(response=json.dumps(response), status=200,
                    mimetype='application/json')


if(__name__ == "__main__"):
   
    app.run(debug=True, port=5000)
`;
            codeArray.push(PySnippet);
            return codeArray;
        } else if (code === 'Java') {
            let JavaSnippet = '';
            JavaSnippet = JavaSnippet + `import java.sql.*;  
class ` + data['executor_name'].charAt(0).toUpperCase() + data['executor_name'].slice(1) + `{  
public static void main(String args[])throws Exception{  
Class.forName("oracle.jdbc.driver.OracleDriver");  
Connection con=DriverManager.getConnection("jdbc:oracle:thin:@localhost:1521:xe","system","` + data['executors'][0]['database']['database_name'] + `");  
Statement stmt=con.createStatement(); 
`;
            if (data['executors'][0]['query'].toLowerCase() === 'select') {
                JavaSnippet = JavaSnippet + `ResultSet rs =stmt.executeUpdate("` + data['executors'][0]['query'] + `");
while (rs.next()) {
  System.out.println(rs.getString(1));
}`;
            } else {
                JavaSnippet = JavaSnippet + `int result=stmt.executeUpdate("` + data['executors'][0]['query'] + `");
System.out.println(result+" records affected");`;
            }
            JavaSnippet = JavaSnippet + `
con.close();  
}}`;
            codeArray.push(JavaSnippet);
            return codeArray;
        }
        return codeArray;
    }

    commitToGitHub() {
        this.confPost.getApiExecutorByPartnerAccountByNameAndVersion(this.data['partner'], this.data['account'], this.data['entityname'], this.data['version']).subscribe(resp => {
            if (resp && resp !== undefined && resp !== null) {
                const data = resp;
                // console.log(resp);
                this.fileName = data['executor_name'] + '.py';
                this.filePath = this.path;
                if (this.filePath === '') {
                    this.filePath = this.fileName;
                } else if (this.filePath !== '' && this.filePath.slice(-1) === '/') {
                    this.filePath = this.filePath + this.fileName;
                } else {
                    this.filePath = this.filePath + '/' + this.fileName;
                }
                const generatedCode = this.generateCode(data, this.selectedCode);
                // console.log(generatedCode);
                if (!this.isRedeployed) {
                    if (this.selectedCode === 'Python') {
                        this.confPost.commitToGitHub(this.data['account'], this.accessToken, this.selectedBranch, this.repoPath, this.filePath, this.fileName, btoa(generatedCode[0]), this.commitMessage).subscribe(res => {
                            this.isCommitted = true;
                            // console.log(res);
                            this.committedFilePath = res['content']['html_url'];
                            const payload = {
                                'account': this.data['account'],
                                'partner': this.data['partner'],
                                'entity_name': this.data['entityname'],
                                'version': this.data['version'],
                                'file_path': this.committedFilePath,
                                'commit_path': res['commit']['html_url'],
                                'author': res['commit']['author']['email'],
                                'commit_date': res['commit']['author']['date'],
                                'sha': res['content']['sha'],
                                'attributes': JSON.stringify(data['executors'][0]['query']),
                                'repository_path': this.repoPath,
                                'branch': this.selectedBranch,
                                'path': this.filePath,
                                'file_name': this.fileName,
                                'code': this.selectedCode,
                                'commit_message': this.commitMessage
                            };
                            this.author = res['commit']['author']['email'];
                            this.committedDate = res['commit']['author']['date'];
                            this.commitPath = res['commit']['html_url'];

                            this.confPost.addItemServices('v1', 'githubCommits', payload).subscribe(res => {
                            });
                        }, err => {
                            this.platform.openSnackBar('Commit Failed. Please try again with different file path ', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        });
                    }
                } else {
                    if (this.selectedCode === 'Python') {
                        this.confPost.mergeToGitHub(this.data['account'], this.accessToken, this.selectedBranch, this.committedRepoPath, this.committedPath, this.committedFileName, btoa(generatedCode[0]), this.committedSha, this.commitMessage).subscribe(res => {
                            this.isCommitted = true;
                            this.isRedeployed = false;
                            // console.log(res);
                            this.committedFilePath = res['content']['html_url'];
                            const payload = {
                                'account': this.data['account'],
                                'partner': this.data['partner'],
                                'entity_name': this.data['entityname'],
                                'version': this.data['version'],
                                'file_path': res['content']['html_url'],
                                'commit_path': res['commit']['html_url'],
                                'author': res['commit']['author']['email'],
                                'commit_date': res['commit']['author']['date'],
                                'sha': res['content']['sha'],
                                'attributes': JSON.stringify(data['executors'][0]['query']),
                                'repository_path': this.committedRepoPath,
                                'branch': this.selectedBranch,
                                'path': this.committedPath,
                                'file_name': this.fileName,
                                'code': this.selectedCode,
                                'commit_message': this.commitMessage
                            };
                            this.author = res['commit']['author']['email'];
                            this.committedDate = res['commit']['author']['date'];
                            this.commitPath = res['commit']['html_url'];

                            this.confPost.addItemServices('v1', 'githubCommits', payload).subscribe(res => {
                            });
                        }, err => {
                            this.platform.openSnackBar('Commit Failed. Please try again with different file path ', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        });
                    }
                }
            }
        }, err1 => {
            this.platform.openSnackBar('Commit Failed. Please try again with different file path ', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    commitAgain() {
        this.isCommitted = false;
    }

    copyMessage(val) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        // selBox.value = $(val).text();
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        this.platform.openSnackBar('Copied to clipboard.', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
    }

    close() {
        this.dialogRef.close();
    }
}
